// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1k-Wz","question":"Question_question__3Ass9","description":"Question_description__3zmca"};